export const set = (property) => (state, payload) => {
  return (state[property] = payload);
};
export const toggle = (property) => (state) => {
  return (state[property] = !state[property]);
};
